import { useQuery } from "@tanstack/react-query";

import { apiClient } from "~/api/ApiClient";
import { queryKeys } from "~/api/queryKeys";

const siteAuthorizeHeaders = {
  "Authorize-Member-Actions":
    "destroy,site_speed_apply,update,widget_toggle,recrawl,crawl,abort_crawl",
};

const getSiteById = async (siteId: number) => {
  const response = await apiClient.sites.sitesDetail(siteId, {
    headers: siteAuthorizeHeaders,
  });

  // @ts-expect-error BE type missed
  const { site, authorizations } = response.data;

  return { site, authorizations };
};

export function useSite(siteId?: number | string | null) {
  const numericId: number | undefined =
    siteId == null ? undefined : Number(siteId);

  return useQuery({
    queryKey: queryKeys.siteDetails(numericId),
    queryFn: () => getSiteById(numericId as number),
    enabled: numericId !== undefined,
    staleTime: 30000,
    refetchOnWindowFocus: false,
  });
}
